module.exports = __webpack_public_path__ + "img/SF2H_logo.df2e5f95.jpg";